import { useContext } from "react";
import { storeContext } from "../mobx/store-context";

export function useAppStore() {
	const context = useContext(storeContext);

	return context;
}
